
<!-- Author Kalpesh created at 07-02-2022 -->
<div class="topdiv">
    <label i18n="@@spmsUserReg" class="textColour">Add Task</label>
    <span class="example-spacer"></span>

    <div class="row" style="margin-top: 15px;">
        <div class="col-12">
            <form novalidate [formGroup]='FormValid'>
                <div style="display: flex; text-align: start;">
                    <div class="col-1"></div>
                    <label class="col-3" style="font-weight: 500;
                    font-size: medium;padding-top: 8px;">Choose File</label>
                        <mat-form-field class="col-5" appearance="outline" style="width: 40rem;">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">File to load</mat-label>
                            <input matInput class="file-path validate" type="text" maxlength="250" placeholder="File to load" formControlName="imageName" id="imageName" [(ngModel)]="statevaluechange.fileName" readonly>
                            <mat-error *ngFor="let validation of validation_messages.filename">
                                <span
                                  *ngIf="FormValid.get('imageName').hasError(validation.type) && (FormValid.get('imageName').dirty || FormValid.get('imageName').touched)">
                                  {{ validation.message }}
                                </span>
                              </mat-error>
                        </mat-form-field>
                        <a class="file-field btn-floating btn-sm m-0">
                            <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>
                            <input type="file" id="imageupload" name="imageupload" (change)="fileupload($event,'csv')" formControlName="imageupload">
                        </a>
                </div>
                <div style="display: flex;">
                    <div class="col-1"></div>
                    <div class="col-10" style="text-align: center;">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@RCselectschedule">Type</mat-label>
                            <mat-select matNativeControl (selectionChange)="typeSelection($event)" [(ngModel)]="type" formControlName="type" ngDefaultControl required>
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let type of selectedType" [value]="type">
                            {{type}}
                            </mat-option>
                            </mat-select>
                            <mat-error *ngFor="let validation of validation_messages.type">
                                <span
                                    *ngIf="FormValid.get('type').hasError(validation.type) && (FormValid.get('type').dirty || FormValid.get('type').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error> 
                        </mat-form-field>
                    </div>
                    <div class="col-1"></div>
                </div>
                <div style="display: flex;">
                    <div class="col-1"></div>
                    <div class="col-10" style="text-align: center;">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@RCFormulaexpression">Object Name</mat-label>
                            <mat-select matNativeControl (selectionChange)="objectSelection($event)" [(ngModel)]="object" formControlName="object" ngDefaultControl>
                              <mat-option>None</mat-option>
                              <mat-option *ngFor="let objectname of selectedobjectName"
                                [value]="objectname">
                                {{objectname}}
                              </mat-option>
                            </mat-select>
                            <mat-error *ngFor="let validation of validation_messages.object">
                                <span
                                    *ngIf="FormValid.get('object').hasError(validation.type) && (FormValid.get('object').dirty || FormValid.get('object').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>  
                          </mat-form-field>
                    </div>
                    <div class="col-1"></div>
                </div>
                <div style="display: flex;">
                    <div class="col-1"></div>
                    <div class="col-10" style="text-align: center;">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@RCselectschedule">Api Operation</mat-label>
                            <mat-select matNativeControl (selectionChange)="operationSelection($event)" [(ngModel)]="operation" formControlName="operation" ngDefaultControl required>
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let operation of selectedOperation"
                                [value]="operation">
                                {{operation}}
                              </mat-option>
                            </mat-select>
                            <mat-error *ngFor="let validation of validation_messages.operation">
                                <span
                                    *ngIf="FormValid.get('operation').hasError(validation.type) && (FormValid.get('operation').dirty || FormValid.get('operation').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error> 
                        </mat-form-field>
                    </div>
                    <div class="col-1"></div>
                </div>
            </form>
        </div>
    </div>


    <div class="row mb-1 topRowMargins" style= "position:sticky;left:0;bottom:0;width:100%;background-color: #fff;">
        <div class="col-lg text-center">
          <div style="text-align: end; margin-top: 15px;"> 

              <button i18n="@@TMRunButton" type="button" (click)="loadFile()" class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              style="padding: .3rem 1.6rem;font-size: .85rem;" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">Add
              <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload example-icon" title="Upload"></em>
            </button>


              <button i18n="@@TMRunButton" type="button" (click)="cancel()" class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              style="padding: .3rem 1.6rem;font-size: .85rem;" [style.border-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean" >Cancel</button>
            
          </div>
        </div>
      </div> 

</div>